import { Link, NavLink, useNavigate } from 'react-router-dom';
import { hTractionLogoWithText } from 'src/assets/images';
import { useState } from 'react';
import cx from "../ScoringEngineLandingPage.module.scss";

const TopNavigation = ({ change }: { change: boolean }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handleSignup = () => {
    navigate('/');
  };

  const handleLogin = () => {
    localStorage.clear();
    if (Object.keys(localStorage).length === 0) {
      navigate('/login');
    } else {
      console.error('Failed to clear local storage');
    }
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <>
      <div className={`header-pd ${change ? 'headActive' : ''}`}>
        <div className="container">
          <div className="landing-page__top-navigation p-0">
            <div>
              <img
                src={hTractionLogoWithText}
                className="landing-page__top-navigation__logo"
                onClick={handleSignup}
                style={{ cursor: 'pointer' }}
              />
            </div>

            <div className={`${cx.header_listing} ${menuOpen ? cx.menuOpen : ''}`}>
              <ul>
                {/* <li>
                  <NavLink to={"/dashboard"}>Explore</NavLink>
                </li> */}
                <li>
                  <NavLink to={"/sign-up"}>Funding Access</NavLink>
                </li>
              </ul>
              <button className={cx.closeButton} onClick={closeMenu}>
                ×
              </button>
            </div>
            <div className='d-flex align-items-center flex-row-reverse'>
              <button className={`${cx.menuToggle} btn`} onClick={toggleMenu}>
                ☰
              </button>
              <div className={`${cx.loginSignUp_btn}`}>
                <button className="btn" onClick={handleLogin}>
                  Login / Signup
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Backdrop */}
      {menuOpen && <div className={cx.backdrop} onClick={closeMenu}></div>}
    </>
  );
};

export default TopNavigation;
